import { render, staticRenderFns } from "./IM_1_1.vue?vue&type=template&id=e95db1b2&scoped=true&"
import script from "./IM_1_1.vue?vue&type=script&lang=js&"
export * from "./IM_1_1.vue?vue&type=script&lang=js&"
import style0 from "./IM_1_1.vue?vue&type=style&index=0&id=e95db1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95db1b2",
  null
  
)

export default component.exports